module.exports = __webpack_public_path__ + "media/packs/user-cards/images/menuDesktop-23a16a882121ec78fda51a21614b8189.svg";